/** Releases API endpoints, merged into the platform API client. */
export const releasesApiEndpoints: Record<string, string> = {
  projectReleases: "/ext/releases/projects/:pk/",
  makeRelease: "POST:/ext/releases/projects/:pk/",
};
